import {MailAttention} from '../components/MailAttention';
import {OriginalEmailBody} from './CommunicationDetail';
import {useEffect,useState} from 'react';
import {api} from '../api';
import {Link} from '../ui/ScopedLink';
import {withBuildingScope} from '../ui/building-scope';
import {formatDateTime} from '../dates';
import {ErrorState,Loading} from '../ui/State';
import {StatusBadge} from '../ui/StatusBadge';

type Message={id:string;subject?:string;sender_address:string;body_text?:string;body_html?:string;occurred_at:string;attachments:{id:string;original_file_name:string}[]};
type Conversation={id:string;title:string;status:string;priority?:string;risk_rating?:string;development_id?:string;development_name?:string;assigned_name?:string;messages:Message[]};

/** A read-only view of the canonical conversation. Sending and record changes remain
 * in the existing permission-checked conversation workflow, so changing rows cannot lose a draft. */
export function MailReadingPane({id,building,attentionReasons=[]}:{id?:string|undefined;building?:string|undefined;attentionReasons?:readonly string[]}){
 const [data,setData]=useState<Conversation>(),[error,setError]=useState<unknown>();
 useEffect(()=>{
  let active=true;setData(undefined);setError(undefined);
  if(id)void api<Conversation>(withBuildingScope('/api/communications/threads/'+id,building))
   .then(value=>{if(value.id!==id||!Array.isArray(value.messages)||building&&value.development_id!==building)throw Error('The conversation could not be confirmed in this building.');if(active)setData(value)}).catch(value=>{if(active)setError(value)});
  return()=>{active=false};
 },[id,building]);
 const href=withBuildingScope('/communications/threads/'+id,building);
 return <aside id="mail-reading-pane" className="mail-reading-pane" aria-label="Reading pane" aria-live="polite">
  {!id?<div className="reading-pane-empty"><h2>Select a conversation</h2><p>Read messages here. Open the conversation to reply, review attachments or update its records.</p></div>
   :error?<ErrorState error={error} subject="Conversation"/>:!data?<Loading/>:<>
    <header>
<h2>{data.title}</h2>
<div className="reading-pane-facts">
<StatusBadge text={data.status}/>
<span>{data.development_name??'Building not confirmed'}</span>
<span>{data.assigned_name??'Unassigned'}</span>
<span>Priority: {data.priority??'Not recorded'}</span>
<span>Risk: {data.risk_rating??'Not recorded'}</span>
</div>
<MailAttention reasons={attentionReasons}/>

</header>
    {[...data.messages].sort((a,b)=>a.occurred_at.localeCompare(b.occurred_at)).map(message=><article className="reading-pane-message" key={message.id}>
     <div className="reading-pane-message__sender"><strong>{message.sender_address}</strong><time>{formatDateTime(message.occurred_at)}</time></div>
     {message.subject&&message.subject!==data.title&&<h3>{message.subject}</h3>}
     {message.body_text?<p className="reading-pane-message__body">{message.body_text}</p>:message.body_html?<OriginalEmailBody html={message.body_html}/>:<p>No message text was supplied.</p>}
     {message.attachments.length>0&&<div className="reading-pane-attachments"><strong>{message.attachments.length} attachments</strong><ul>{message.attachments.map(file=><li key={file.id}><Link to={href}>{file.original_file_name}</Link></li>)}</ul></div>}
    </article>)}
    <footer className="reading-pane-actions"><Link className="button-link secondary" to={href}>Open conversation</Link></footer>
   </>}
 </aside>;
}
